export default __webpack_public_path__ + "static/media/teal.c3f01092.png";